module.exports = __webpack_public_path__ + "static/satellogic-fd68bf5f0f8b7b9c661edb8f6a56ca20.png";